import { Play } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionPlay(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Play size={16} className='action_btn text-success me-3'
                    onClick={onClick}
                    data-tooltip-id='play'
                    data-tooltip-content={text}
                    data-tooltip-place="top"
                />
            }

            <Tooltip id='play' className='bg-success tooltip_msg' />
        </>
    )
}